export const fileSelectTitle = 'Un-Edited RAW image files';
export const emptySetTitle = 'No extra RAW images';
export const emptySetDescription = 'Uploaded any extra raw files here in case the client requests them later.';
